import apiClient from "./client";

export async function getCompanyMembers() {
  const res = await apiClient.get("/api/company/members");
  const data = await res.json();
  if (!res.ok) throw new Error(data.message);
  return data;
}

export async function inviteMember({ email, full_name, is_admin }) {
  const res = await apiClient.post("/api/company/invite-member", { email, full_name, is_admin });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message);
  return data;
}

export async function acceptInvite({ invite_token, password }) {
  const res = await apiClient.post("/api/company/accept-invite", { invite_token, password }, { auth: false });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message);
  return data;
}

export async function updateMemberRole(userId, role, full_name, email) {
  const res = await apiClient.patch(`/api/company/members/${userId}`, { role, full_name, email });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message);
  return data;
}

export async function removeMember(userId) {
  const res = await apiClient.delete(`/api/company/members/${userId}`);
  const data = await res.json();
  if (!res.ok) throw new Error(data.message);
  return data;
}

export async function cancelInvitation(inviteToken) {
  const res = await apiClient.delete(`/api/company/invitations/${inviteToken}`);
  const data = await res.json();
  if (!res.ok) throw new Error(data.message);
  return data;
}

export async function searchMembers(query) {
  const res = await apiClient.get(`/api/company/search-members?q=${encodeURIComponent(query)}`);
  const data = await res.json();
  if (!res.ok) throw new Error(data.message);
  return data;
}

export async function assignBoardMember(companySlug, boardSlug, userId, role) {
  const res = await apiClient.post("/api/board-members/assign", { company_slug: companySlug, board_slug: boardSlug, user_id: userId, role });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message);
  return data;
}

export async function removeBoardMember(companySlug, boardSlug, userId) {
  const res = await apiClient.delete("/api/board-members/remove", { company_slug: companySlug, board_slug: boardSlug, user_id: userId });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message);
  return data;
}

export async function getBoardMembers(companySlug, boardSlug) {
  const res = await apiClient.get(`/api/board-members/${companySlug}/${boardSlug}`);
  const data = await res.json();
  if (!res.ok) throw new Error(data.message);
  return data;
}
